<template>
    <CDropdown
        inNav
        class="c-header-nav-items"
        placement="bottom-end"
        add-menu-classes="pt-0"
    >
        <template #toggler>
            <div class="position-relative">
                <CBadge class="notification--badge" color="danger">{{ totalNotifications }}</CBadge>
                <CHeaderNavLink>
                    <CIcon :content="$options.icons.cilBell" size="xl" />
                </CHeaderNavLink>
            </div>
            
        </template>
        <CDropdownHeader tag="div" class="text-cent\er" color="light">
            <strong>{{ $t("settings") }}</strong>
        </CDropdownHeader>
        <CDropdownItem
            v-for="notification in notifications"
            :key="notification.id"
            @click="markAsReaded(notification)"
        >
            <CIcon name="cil-user" />
            {{ $t(getTextFromTitle(notification.title))+ " " + getNameFromTitle(notification.title) }}
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem @click="$router.push({ name: 'notifications' })">
            {{ $t("view_all_notifications") }}
        </CDropdownItem>
    </CDropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { cilBell } from "@coreui/icons";
import { QueryBuilder } from "~/utils/queryBuilder.js";
import pageMixin from "~/mixins/page.js";
export default {
    // Header Account
    mixins: [pageMixin],
    icons: {
        cilBell,
    },
    data() {
        return {
            notifications: [],
            totalNotifications: 0,
        };
    },
    computed: {},
    methods: {
        getNameFromTitle(title) {
            let pos = title.indexOf(" ");
            return title.substring(pos + 1, title.length);
        },
        getTextFromTitle(title) {
            let pos = title.indexOf(" ");
            return title.substring(0, pos);
        },
        async loadNotifications() {
            let query = new QueryBuilder();
            query.equals("readed", false);
            query.orderBy("created_at", "desc");
            const data = await this.loadData({
                url: "/notification.api/list",
                query: query.toString(),
            });
            this.notifications = data._items;
            this.totalNotifications = data.count;
        },

        getNotificationTitle(notification) {
            
            // Split by space
            let title = notification.title.split(" ");

            return this.$t(notification.title[0]) + " " + title[1];
        },

        async markAsReaded(notification) {
            await this.loadData({
                url: "/notification.api/readed/" + notification.uuid,
                method: "PUT",
            });
            this.loadNotifications();

            let route = this.generateRoute(notification);
            if(route){
                this.$router.push(route)
            }
            
        },

        generateRoute(notification) {
            let route = {};

            switch (notification.type) {
                case "notification.provider_event_capping":
                    route = {
                        ...route,
                        path: "/app/campaings",
                    }
                    this.$store.dispatch('page/addFilterWhere', {
                        id: {
                            equals: notification.code
                        }
                    } );
                    break;
                case "client_integration":
                    route = {
                        ...route,
                        path: "/app/delivery_campaings",
                    }
                    this.$store.dispatch('page/addFilterWhere', {
                        id : {
                            equals: notification.code.split('|')[0]
                        }
                    } );
                default:
                    break;
            }

            return route
        },
    },
    async mounted() {
        await this.loadNotifications();
    },
};
</script>

<style scoped>
.c-icon {
    margin-right: 0.3rem;
}
.user-name {
    margin-right: 1em;
}
</style>
